import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "contact-me",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Say, Hello!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Send ", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "name",
      placeholder: "Full Name",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
      "data-aos": "slide-right",
      "data-aos-easing": "ease"
    }, null, 512), [
      [
        _vModelText,
        _ctx.name,
        void 0,
        { trim: true }
      ]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "email",
      placeholder: "E-mail",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
      "data-aos": "slide-right",
      "data-aos-easing": "ease"
    }, null, 512), [
      [
        _vModelText,
        _ctx.email,
        void 0,
        { trim: true }
      ]
    ]),
    _withDirectives(_createElementVNode("textarea", {
      name: "message",
      placeholder: "Your Message",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
      maxlength: "2048",
      "data-aos": "slide-right",
      "data-aos-easing": "ease"
    }, null, 512), [
      [
        _vModelText,
        _ctx.message,
        void 0,
        { trim: true }
      ]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invalidMessages, (err, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "error-message",
          "data-aos": "zoom-in",
          "data-aos-easing": "ease",
          key: index
        }, _toDisplayString(err), 1))
      }), 128))
    ], 512), [
      [_vShow, _ctx.invalidMessages.length > 0]
    ]),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
      "data-aos": "slide-up",
      "data-aos-easing": "ease"
    }, _hoisted_4)
  ]))
}